import { useCallback } from "react"
import { postSubmit } from "@ui-seeker/utils"
import { BACKEND_APIS } from "@constants"
import { isEditLoading, tableFormsData } from "Pages/Admin/OfficeMapping/@signals"
import { offices } from "@signals"
import { useToast } from "@hooks"

export default function useTableEdit() {
	const { showToast } = useToast()


	const onSubmit = useCallback((rowIndex, { idSite, name }) => {
		isEditLoading.value = rowIndex
		postSubmit(`${BACKEND_APIS.OFFICE_MAPPING}/editable`, {
			idOffice: offices.value,
			idSite: idSite,
			config: tableFormsData.value[rowIndex]
		})
			.then(() => {
				showToast.success(`${name} successfully mapped!`)
				isEditLoading.value = null
			})
			.catch(() => {
				showToast.error(`An error has occurred mapping ${name}`)
				isEditLoading.value = null
			})
	}, [])

	return {
		onSubmit
	}
}